/**
 * Do not edit directly, this file was auto-generated.
 */

export const semanticTokensBrandStrongSurface = "#3e73ed";
export const semanticTokensBrandStrongSurfaceHover = "#1b3fb0";
export const semanticTokensBrandStrongText = "#1b3fb0";
export const semanticTokensBrandStrongBorder = "#1b3fb0";
export const semanticTokensBrandWeakSurface = "#e4eeff";
export const semanticTokensSuccessStrongText = "#0a3500";
export const semanticTokensSuccessDefaultBorder = "#158000";
export const semanticTokensSuccessDefaultText = "#158000";
export const semanticTokensSuccessDefaultSurfaceHover = "#106000";
export const semanticTokensSuccessDefaultSurface = "#1d9608";
export const semanticTokensSuccessWeakSurface = "#bee8c3";
export const semanticTokensSuccessXweakSurface = "#e7f8e9";
export const semanticTokensDangerStrongText = "#8e0505";
export const semanticTokensDangerStrongSurface = "#d52727";
export const semanticTokensDangerStrongSurfaceHover = "#a60707";
export const semanticTokensDangerStrongBorder = "#d52727";
export const semanticTokensDangerDefaultSurface = "#ffe5e5";
export const semanticTokensDangerDefaultText = "#d52727";
export const semanticTokensDangerWeakSurface = "#fff2f2";
export const semanticTokensAttentionStrongText = "#4e1c00";
export const semanticTokensAttentionDefaultText = "#c66028";
export const semanticTokensAttentionDefaultSurface = "#ffe9dd";
export const semanticTokensAttentionSecondaryDefaultText = "#42037d";
export const semanticTokensAttentionSecondaryDefaultSurface = "#eedffb";
export const semanticTokensLinkDefaultText = "#308ab5";
export const semanticTokensNeutralXstrongSurface = "#374050";
export const semanticTokensNeutralStrongSurface = "#505d73";
export const semanticTokensNeutralStrongBackground = "rgba(55, 57, 56, 0.5)";
export const semanticTokensNeutralStrongBorder = "#3e495c";
export const semanticTokensNeutralDefaultText = "#374050";
export const semanticTokensNeutralDefaultSurface = "#8290a6";
export const semanticTokensNeutralDefaultSurfaceHover = "#67758d";
export const semanticTokensNeutralDefaultBackground = "#ffffff";
export const semanticTokensNeutralDefaultBorder = "#c0cadc";
export const semanticTokensNeutralWeakText = "#67758d";
export const semanticTokensNeutralWeakSurface = "#eaeef8";
export const semanticTokensNeutralWeakBorder = "#dde3f0";
export const semanticTokensNeutralXweakText = "#a3afc4";
export const semanticTokensNeutralXweakSurface = "#f5f8fb";
export const semanticTokensInverseDefaultText = "#ffffff";
export const semanticTokensInverseDefaultSurface = "#ffffff";
